module.exports = __webpack_public_path__ + "img/products_big_can_mango_ru.7fcde693.png";